/* swt-bundle.js · Build Your Bundle (sections/swt-bundle.liquid)   v3 10-28-26
   <swt-bundle> custom element.
   v3: final approved rules, same maths as the SWT Bundle Discount app v2
   (extensions/bundle-discount/src/cart_lines_discounts_generate_run.js):
   - 1 device per bundle. It counts toward the tier, never gets the %.
   - Add-ons (cfg.addonTypes) count once per product if the price is at least
     cfg.minAddon ($15). Other types don't count.
   - Tier % (up to 10% / 15%) applies to 1 unit of each add-on, capped at the
     variant's own limit ("m", max 25%). v2.2: sections/swt-bundle-data.liquid works
     "m" out from the website price + hidden cost (swt_bundle.cost); fallback
     swt_bundle.max_pct; blank = 0%.
   - Sale (compare-at above price), Open Box and Preowned (-OB / -PO SKUs)
     count but get 0%. Deals of the Week items are hidden.
   - Total saving capped at cfg.cap ($75); every line scales down evenly.
   - Each item card says whether it carries the saving; the summary shows the
     saving per line.
   v2 notes:
   - Step 1: up to cfg.maxDevices devices. Each is a new device (popular tile
     or predictive search, then /products/<handle>.js for variants, added to
     the cart) or one the shopper already owns (brand/model from the swt_device
     metaobjects, used to filter only).
   - A new device is matched to an swt_device by model number in its SKUs or
     title (same data as the product-page compatibility checker).
   - Add-on steps load /collections/<handle>?section_id=swt-bundle-data&page=N
     and keep only items that fit the device chosen in that step's "For" tabs:
     custom.compat_devices, else custom.compat_rule (rules copied from
     snippets/swt-compat.liquid), else the step's fallback.
   - Picks are per device. "Most picks per device" = 1 swaps instead of
     blocking.
   - Savings are an estimate from the tier settings. Devices count toward the
     tier and never get the % (v3). Checkout uses the
     bundle discount function.
   - Add to cart: one /cart/add.js call with every line (each its own SKU) plus
     hidden _bundle / _bundle_size / _bundle_role / _bundle_for properties,
     then the Rebuy Smart Cart. */
(function () {
  if (customElements.get('swt-bundle')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- helpers ---------- */
  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; }); }
  function norm(s) { return String(s || '').toUpperCase().replace(/\s+/g, '').replace(/^SM-/, ''); }
  function img(url, w) {
    if (!url) return '';
    url = String(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function list(s) {
    return (Array.isArray(s) ? s : String(s || '').split(','))
      .map(function (x) { return String(x).trim(); })
      .filter(Boolean);
  }
  function lower(arr) { return arr.map(function (x) { return x.toLowerCase(); }); }
  function isOpenBox(title, tags) {
    if (/^open box\b/i.test(String(title || ''))) return true;
    return (tags || []).some(function (t) { return /^open box$/i.test(t); });
  }
  /* Swiftronics marks every Open Box / Preowned SKU with -OB or -PO. */
  function isUsedSku(sku) { return /-(ob|po)$/i.test(String(sku || '').trim()); }
  function shortName(title) {
    var t = String(title || '').split(' (')[0].split(' - ')[0].trim();
    return t.length > 42 ? t.slice(0, 40).trim() + '…' : t;
  }
  function bundleId() { return 'B' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase(); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>';
  var ICON_SWAP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7 7h11l-3-3M17 17H6l3 3"/></svg>';
  var ICON_INFO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_PHONE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><rect x="7" y="2.5" width="10" height="19" rx="2.5"/><path d="M11 18.5h2"/></svg>';

  /* ---------- fit rules (from snippets/swt-compat.liquid) ---------- */
  var LIGHT = ['iphone-11', 'iphone-13', 'iphone-14', 'iphone-14-plus', 'iphone-14-pro', 'iphone-14-pro-max', 'ipad-7th-gen', 'ipad-8th-gen', 'ipad-9th-gen', 'ipad-air-3rd-gen', 'ipad-pro-10-5'];
  var NOMAG = ['iphone-11', 'iphone-16e'];
  function judgeRule(rule, d) {
    var apple = /^Apple /.test(d.f), iphone = d.f === 'Apple iPhone', tab = /iPad|Pad|Tab/.test(d.f), light = LIGHT.indexOf(d.h) > -1;
    switch (rule) {
      case 'bluetooth': return { s: 'ok', w: 'Works over Bluetooth' };
      case 'any_phone': return tab ? { s: 'no' } : { s: 'ok', w: 'Works with any phone' };
      case 'android_phone': return (tab || apple) ? { s: 'no' } : { s: 'ok', w: 'Works with Android phones' };
      case 'iphone': return iphone ? { s: 'ok', w: 'Works with iPhone' } : { s: 'no' };
      case 'usb_c': return light ? { s: 'no' } : { s: 'ok', w: 'Fits your USB-C port' };
      case 'lightning': return light ? { s: 'ok', w: 'Fits your Lightning port' } : { s: 'no' };
      case 'charger': return light ? { s: 'part', w: 'Needs a USB-C to Lightning cable' } : { s: 'ok', w: 'Charges your device' };
      case 'magsafe':
        if (tab) return { s: 'no' };
        if (iphone && NOMAG.indexOf(d.h) < 0) return { s: 'ok', w: 'MagSafe fit' };
        return { s: 'part', w: 'Needs a magnetic (MagSafe) case' };
      case 'wireless':
        if (tab) return { s: 'no' };
        return iphone ? { s: 'ok', w: 'Wireless charging' } : { s: 'part', w: 'If your phone has wireless charging' };
    }
    return { s: 'ok', w: '' };
  }

  class SwtBundle extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.cfg = JSON.parse(this.querySelector('[data-bdl-config]').textContent);
      } catch (e) {
        return;
      }
      var cfg = this.cfg;
      this.types = lower(list(cfg.types));
      this.excl = lower(list(cfg.excludeVendors));
      this.ceiling = Number(cfg.ceiling) > 0 ? Number(cfg.ceiling) : 25;
      var ceil = this.ceiling;
      this.tiers = (cfg.tiers || []).filter(function (t) { return t && t.q > 0 && t.p > 0; })
        .map(function (t) { return { q: t.q, p: Math.min(t.p, ceil) }; })
        .sort(function (a, b) { return a.q - b.q; });
      /* Approved rule: 1 device per bundle (checkout counts at most 1). */
      this.maxDev = Math.max(1, Math.min(Number(cfg.maxDevices) || 1, 5));
      this.addonTypes = lower(list(cfg.addonTypes || 'Accessories, Phone Case, Headphones, Smartwatch, Speakers'));
      var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
      this.minCents = Math.round((Number(cfg.minAddon) >= 0 ? Number(cfg.minAddon) : 15) * rate * 100);
      this.capCents = Math.round((Number(cfg.cap) > 0 ? Number(cfg.cap) : 75) * rate * 100);
      this.fmt = this.makeFormatter();
      this.devices = (cfg.devices || []).filter(function (d) { return d && d.n; });
      /* devs: [{key, kind: new|own, product, variant, match, own, name}] */
      this.state = { mode: 'buy', devs: [], picks: [], active: {}, adderOpen: true };
      this.seq = 0;
      this.data = {};     // step id -> items[]
      this.expanded = {}; // step id -> true when "Show all" is on

      this.q = function (sel) { return this.querySelector(sel); }.bind(this);
      this.qa = function (sel) { return Array.prototype.slice.call(this.querySelectorAll(sel)); }.bind(this);
      var lockEl = this.q('[data-bdl-step] .swt-bdl__empty');
      this.lockText = lockEl ? lockEl.textContent.trim() : 'Pick your device in step 1 to see what fits.';

      this.bindDevice();
      this.bindSteps();
      this.bindSummary();
      this.fillFamilies();
      this.loadSteps();
      this.devicesChanged();
    }

    makeFormatter() {
      var cfg = this.cfg;
      var loc = (cfg.locale || 'en') + (cfg.country ? '-' + cfg.country : '');
      var nf;
      try {
        nf = new Intl.NumberFormat(loc, { style: 'currency', currency: cfg.currency || 'CAD', currencyDisplay: 'narrowSymbol' });
      } catch (e) {
        nf = new Intl.NumberFormat('en', { style: 'currency', currency: cfg.currency || 'CAD' });
      }
      return function (cents) { return nf.format((cents || 0) / 100); };
    }

    say(msg) {
      var el = this.q('[data-bdl-status]');
      if (!el) return;
      el.textContent = '';
      window.setTimeout(function () { el.textContent = msg; }, 30);
    }

    /* ======================= Step 1: devices ======================= */
    bindDevice() {
      var self = this;
      this.qa('[data-bdl-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.setMode(btn.getAttribute('data-bdl-mode')); });
      });

      var input = this.q('[data-bdl-q]');
      var results = this.q('[data-bdl-results]');
      var timer = null;
      if (input) {
        input.addEventListener('input', function () {
          window.clearTimeout(timer);
          var term = input.value.trim();
          if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
          timer = window.setTimeout(function () { self.search(term); }, 250);
        });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { input.value = ''; results.hidden = true; results.innerHTML = ''; }
        });
      }
      if (results) {
        results.addEventListener('click', function (e) {
          var b = e.target.closest('[data-bdl-pick]');
          if (!b) return;
          results.hidden = true;
          results.innerHTML = '';
          if (input) input.value = '';
          self.addNewDevice(b.getAttribute('data-bdl-pick'));
        });
      }
      var popular = this.q('[data-bdl-popular]');
      if (popular) {
        popular.addEventListener('click', function (e) {
          var b = e.target.closest('[data-bdl-pick]');
          if (b && !b.disabled) self.addNewDevice(b.getAttribute('data-bdl-pick'));
        });
      }
      var dlist = this.q('[data-bdl-dlist]');
      if (dlist) {
        dlist.addEventListener('click', function (e) {
          var rm = e.target.closest('[data-bdl-drm]');
          if (rm) { self.removeDevice(rm.getAttribute('data-bdl-drm')); return; }
          var pill = e.target.closest('[data-bdl-opt]');
          if (pill) self.pickOption(pill.getAttribute('data-bdl-dk'), Number(pill.getAttribute('data-bdl-opt')), pill.getAttribute('data-value'));
        });
      }
      var more = this.q('[data-bdl-addmore]');
      if (more) more.addEventListener('click', function () { self.openAdder(true); });
      var cancel = this.q('[data-bdl-cancel]');
      if (cancel) cancel.addEventListener('click', function () { self.openAdder(false); });

      var fam = this.q('[data-bdl-fam]');
      var model = this.q('[data-bdl-model]');
      if (fam) fam.addEventListener('change', function () { self.fillModels(); });
      if (model) {
        model.addEventListener('change', function () {
          if (model.value === '') return;
          self.addOwnDevice(self.devices[Number(model.value)]);
        });
      }
    }

    setMode(mode) {
      if (mode === this.state.mode) return;
      this.state.mode = mode;
      this.qa('[data-bdl-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-bdl-mode') === mode ? 'true' : 'false'); });
      this.qa('[data-bdl-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-bdl-panel') !== mode; });
    }

    openAdder(open) {
      this.state.adderOpen = !!open;
      this.renderDevices();
      if (open) {
        var first = this.state.mode === 'own' ? this.q('[data-bdl-fam]') : this.q('[data-bdl-q]');
        if (first) first.focus({ preventScroll: true });
      } else {
        var more = this.q('[data-bdl-addmore]');
        if (more && !more.hidden) more.focus({ preventScroll: true });
      }
    }

    hasRoom() {
      if (this.state.devs.length < this.maxDev) return true;
      this.showError('You can add up to ' + plural(this.maxDev, 'device', 'devices') + ' to one bundle.');
      return false;
    }

    renderPopular() {
      var wrap = this.q('[data-bdl-popular]');
      if (!wrap) return;
      var fmt = this.fmt;
      var inBundle = {};
      this.state.devs.forEach(function (d) { if (d.kind === 'new') inBundle[d.product.handle] = true; });
      var html = (this.cfg.popular || []).filter(function (p) { return p && p.h; }).map(function (p) {
        var tag = !p.a ? 'Sold out' : (inBundle[p.h] ? 'In your bundle' : 'From ' + fmt(p.p));
        return '<button type="button" class="swt-bdl__dev' + (inBundle[p.h] ? ' is-in' : '') + '" data-bdl-pick="' + esc(p.h) + '"' + (p.a ? '' : ' disabled') + ' data-track-action="device-popular">' +
          '<span class="swt-bdl__dev-img">' + (p.img ? '<img src="' + esc(img(p.img, 300)) + '" alt="" loading="lazy" width="300" height="300">' : '') + '</span>' +
          '<span class="swt-bdl__dev-v">' + esc(p.v) + '</span>' +
          '<span class="swt-bdl__dev-t">' + esc(shortName(p.t)) + '</span>' +
          '<span class="swt-bdl__dev-p">' + (inBundle[p.h] ? ICON_CHECK : '') + esc(tag) + '</span>' +
          '</button>';
      }).join('');
      wrap.innerHTML = html;
      var label = wrap.previousElementSibling;
      if (label) label.hidden = !html;
    }

    search(term) {
      var self = this;
      var results = this.q('[data-bdl-results]');
      /* Only search the device types, so cases don't push phones out of the 10 results. */
      var typed = this.types.length ? term + ' (' + list(this.cfg.types).map(function (t) { return 'product_type:"' + t + '"'; }).join(' OR ') + ')' : term;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(typed) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
      this.searchTerm = term;
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (self.searchTerm !== term) return;
          var items = (((data || {}).resources || {}).results || {}).products || [];
          items = items.filter(function (p) {
            if (self.cfg.excludeOpenBox && isOpenBox(p.title, p.tags)) return false;
            if (!self.types.length) return true;
            return self.types.indexOf(String(p.type || '').toLowerCase()) > -1;
          }).slice(0, 6);
          if (!items.length) {
            results.innerHTML = '<p class="swt-bdl__result-empty">No phones or tablets found.</p>';
          } else {
            results.innerHTML = items.map(function (p) {
              var im = (p.featured_image && p.featured_image.url) || p.image || '';
              var price = p.price_min || p.price;
              var cents = Math.round(parseFloat(price || 0) * 100);
              return '<button type="button" class="swt-bdl__result" data-bdl-pick="' + esc(p.handle) + '" data-track-action="device-search">' +
                (im ? '<img src="' + esc(img(im, 120)) + '" alt="" loading="lazy" width="44" height="44">' : '') +
                '<span><strong>' + esc(String(p.title || '').split(' - ')[0]) + '</strong><small>From ' + self.fmt(cents) + '</small></span></button>';
            }).join('');
          }
          results.hidden = false;
        })
        .catch(function () {
          results.innerHTML = '<p class="swt-bdl__result-empty">Search is not available right now.</p>';
          results.hidden = false;
        });
    }

    addNewDevice(handle) {
      var self = this;
      if (this.loadingDevice || !this.hasRoom()) return;
      this.loadingDevice = true;
      var dlist = this.q('[data-bdl-dlist]');
      dlist.hidden = false;
      var skel = document.createElement('li');
      skel.className = 'swt-bdl__dcard swt-bdl__dcard--loading';
      skel.innerHTML = '<span class="swt-bdl__skel" style="aspect-ratio:auto;height:96px"></span>';
      dlist.appendChild(skel);
      this.q('[data-bdl-adder]').hidden = true;
      this.q('[data-bdl-addmore]').hidden = true;
      var done = function () {
        self.loadingDevice = false;
        if (skel.parentNode) skel.remove();
      };
      fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('missing'); return r.json(); })
        .then(function (p) {
          var variant = p.variants.filter(function (v) { return v.available; })[0];
          if (!variant) throw new Error('soldout');
          var match = self.matchDevice(p);
          var dev = { key: 'D' + (++self.seq), kind: 'new', product: p, variant: variant, match: match, name: match ? match.n : shortName(p.title) };
          done();
          self.state.devs.push(dev);
          self.state.adderOpen = false;
          self.focusDevice(dev.key);
          self.devicesChanged();
          self.say(dev.name + ' added to your bundle.');
        })
        .catch(function (err) {
          done();
          self.showError(err && err.message === 'soldout' ? 'That one is sold out. Pick another.' : 'Could not load that device. Try again.');
          self.renderDevices();
        });
    }

    addOwnDevice(d) {
      if (!d) return;
      var exists = this.state.devs.some(function (x) { return x.kind === 'own' && x.own.h === d.h; });
      var model = this.q('[data-bdl-model]');
      if (exists) {
        this.showError('Your ' + d.n + ' is already in the list.');
        if (model) model.value = '';
        return;
      }
      if (!this.hasRoom()) { if (model) model.value = ''; return; }
      var dev = { key: 'D' + (++this.seq), kind: 'own', own: d, name: d.n };
      this.state.devs.push(dev);
      this.state.adderOpen = false;
      var fam = this.q('[data-bdl-fam]');
      if (fam) fam.value = '';
      this.fillModels();
      this.focusDevice(dev.key);
      this.devicesChanged();
      this.say('Showing add-ons for your ' + d.n + '.');
    }

    /* Every step switches to the device just added. */
    focusDevice(key) {
      var self = this;
      (this.cfg.steps || []).forEach(function (s) { self.state.active[s.id] = key; });
    }

    removeDevice(key) {
      var dev = this.dev(key);
      if (!dev) return;
      var before = this.state.picks.length;
      this.state.devs = this.state.devs.filter(function (d) { return d.key !== key; });
      this.state.picks = this.state.picks.filter(function (pk) { return pk.dev !== key; });
      var dropped = before - this.state.picks.length;
      var self = this;
      Object.keys(this.state.active).forEach(function (sid) {
        if (self.state.active[sid] === key) delete self.state.active[sid];
      });
      if (!this.state.devs.length) this.state.adderOpen = true;
      this.devicesChanged();
      this.say(dev.name + ' removed' + (dropped ? ', with ' + plural(dropped, 'add-on', 'add-ons') + ' picked for it.' : '.'));
      var focus = this.state.devs.length ? this.q('[data-bdl-drm]') : this.q('[data-bdl-q]');
      if (focus) focus.focus({ preventScroll: true });
    }

    dev(key) { return this.state.devs.filter(function (d) { return d.key === key; })[0] || null; }

    /* Label used in tabs and the summary: "OnePlus 15", or "OnePlus 15 (2)"
       when two devices share a name. */
    label(dev) {
      var same = this.state.devs.filter(function (d) { return d.name === dev.name; });
      if (same.length < 2) return dev.name;
      return dev.name + ' (' + (same.indexOf(dev) + 1) + ')';
    }

    /* Match a product to an swt_device: model number in a SKU segment or in
       the title, else the longest device name the title starts with. */
    matchDevice(p) {
      var segs = {};
      (p.variants || []).forEach(function (v) {
        String(v.sku || '').split(/[-\/\s_]+/).forEach(function (s) { if (s) segs[norm(s)] = true; });
      });
      var title = String(p.title || '').toUpperCase();
      var hit = null;
      this.devices.some(function (d) {
        return (d.m || []).some(function (m) {
          var n = norm(m);
          if (n.length < 4) return false;
          var raw = String(m).toUpperCase();
          if (segs[n] || title.indexOf('(' + raw) > -1 || title.indexOf(raw + ')') > -1) { hit = d; return true; }
          return false;
        });
      });
      if (hit) return hit;
      var best = null;
      this.devices.forEach(function (d) {
        var n = String(d.n || '').toUpperCase();
        if (!n || title.indexOf(n) !== 0) return;
        var next = title.charAt(n.length);
        if (next && /[A-Z0-9+]/.test(next)) return;
        if (!best || n.length > best.n.length) best = d;
      });
      return best;
    }

    /* A stand-in device for rule checks when no swt_device matched. */
    pseudoDevice(p) {
      var v = String(p.vendor || '');
      var tab = /tablet/i.test(p.type || '') || /\b(pad|tab)\b/i.test(p.title || '');
      var f = v;
      if (/^apple$/i.test(v)) f = tab ? 'Apple iPad' : 'Apple iPhone';
      else if (tab) f = v + ' Pad';
      return { h: '', n: shortName(p.title), f: f, m: [] };
    }

    deviceCard(dev) {
      var fmt = this.fmt, self = this;
      var name = this.label(dev);
      var check14 = ICON_CHECK.replace('<svg', '<svg width="14" height="14"');
      var info14 = ICON_INFO.replace('<svg', '<svg width="14" height="14"');
      if (dev.kind === 'own') {
        return '<li class="swt-bdl__dcard is-own" data-bdl-dk="' + dev.key + '">' +
          '<div class="swt-bdl__picked-top">' +
            '<span class="swt-bdl__picked-img swt-bdl__picked-img--icon">' + ICON_PHONE + '</span>' +
            '<span class="swt-bdl__picked-info">' +
              '<span class="swt-bdl__label">' + esc(dev.own.f || '') + '</span>' +
              '<strong>' + esc(name) + '</strong>' +
              '<span class="swt-bdl__owned">Already yours · not added to cart</span>' +
              '<span class="swt-bdl__fitline">' + check14 + 'Showing add-ons that fit</span>' +
            '</span>' +
            '<button type="button" class="swt-bdl__change" data-bdl-drm="' + dev.key + '" aria-label="Remove ' + esc(name) + '" data-track-action="device-remove">Remove</button>' +
          '</div>' +
        '</li>';
      }
      var p = dev.product, v = dev.variant;
      var image = (v.featured_image && v.featured_image.src) || p.featured_image || '';
      var opts = '';
      if (p.options && p.options.length && !(p.options.length === 1 && /^title$/i.test(p.options[0].name || p.options[0]))) {
        opts = '<div class="swt-bdl__opts">' + p.options.map(function (o, i) {
          var oname = o.name || o;
          var values = (o.values || []).slice();
          if (!values.length) {
            p.variants.forEach(function (x) { if (values.indexOf(x.options[i]) < 0) values.push(x.options[i]); });
          }
          return '<div class="swt-bdl__optgroup"><span class="swt-bdl__label">' + esc(oname) + '</span><div class="swt-bdl__pills">' +
            values.map(function (val) {
              var on = v.options[i] === val;
              var any = p.variants.some(function (x) {
                return x.available && x.options[i] === val && x.options.every(function (ov, j) { return j === i || ov === v.options[j]; });
              });
              return '<button type="button" class="swt-v2-option' + (any ? '' : ' is-dim') + '" data-bdl-dk="' + dev.key + '" data-bdl-opt="' + i + '" data-value="' + esc(val) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(val) + '</button>';
            }).join('') + '</div></div>';
        }).join('') + '</div>';
      }
      var fitLine = dev.match ?
        '<span class="swt-bdl__fitline">' + check14 + 'Showing add-ons that fit</span>' :
        '<span class="swt-bdl__fitline">' + info14 + 'Showing add-ons that work with most phones</span>';
      return '<li class="swt-bdl__dcard" data-bdl-dk="' + dev.key + '">' +
        '<div class="swt-bdl__picked-top">' +
          '<span class="swt-bdl__picked-img">' + (image ? '<img src="' + esc(img(image, 240)) + '" alt="" width="96" height="96">' : '') + '</span>' +
          '<span class="swt-bdl__picked-info">' +
            '<span class="swt-bdl__label">' + esc(p.vendor) + '</span>' +
            '<strong>' + esc(name) + '</strong>' +
            '<span class="swt-bdl__picked-price">' + fmt(v.price) + '</span>' +
            fitLine +
          '</span>' +
          '<button type="button" class="swt-bdl__change" data-bdl-drm="' + dev.key + '" aria-label="Remove ' + esc(name) + '" data-track-action="device-remove">Remove</button>' +
        '</div>' + opts +
      '</li>';
    }

    renderDevices() {
      var s = this.state, n = s.devs.length, self = this;
      var dlist = this.q('[data-bdl-dlist]');
      if (!this.loadingDevice) {
        dlist.innerHTML = s.devs.map(function (d) { return self.deviceCard(d); }).join('');
        dlist.hidden = !n;
      }
      var room = n < this.maxDev;
      var adderShown = room && (s.adderOpen || !n);
      if (this.loadingDevice) adderShown = false;
      this.q('[data-bdl-adder]').hidden = !adderShown;
      this.q('[data-bdl-adderhead]').hidden = !n;
      var more = this.q('[data-bdl-addmore]');
      more.hidden = !n || !room || adderShown || !!this.loadingDevice;
      this.q('[data-bdl-addmore-label]').textContent = 'Add another device';
      var count = this.q('[data-bdl-devcount]');
      count.textContent = (n && this.maxDev > 1) ? n + ' of ' + this.maxDev : '';
      this.q('[data-bdl-device]').classList.toggle('is-done', n > 0);
      this.renderPopular();
    }

    pickOption(key, i, val) {
      var dev = this.dev(key);
      if (!dev || dev.kind !== 'new') return;
      var p = dev.product, v = dev.variant;
      var want = v.options.slice();
      want[i] = val;
      var exact = p.variants.filter(function (x) { return x.options.every(function (ov, j) { return ov === want[j]; }); })[0];
      var next = (exact && exact.available) ? exact :
        p.variants.filter(function (x) { return x.available && x.options[i] === val; })[0];
      if (!next) { this.showError('That option is sold out.'); return; }
      dev.variant = next;
      this.renderDevices();
      this.render();
      var pill = this.q('[data-bdl-dk="' + key + '"][data-bdl-opt="' + i + '"][aria-pressed="true"]');
      if (pill) pill.focus({ preventScroll: true });
    }

    fillFamilies() {
      var fam = this.q('[data-bdl-fam]');
      if (!fam) return;
      var cmp = function (x, y) { return String(x).localeCompare(String(y), undefined, { numeric: true, sensitivity: 'base' }); };
      var other = function (f) { return f === 'Other phones' ? 1 : 0; };
      this.devices.sort(function (a, b) { return (other(a.f) - other(b.f)) || cmp(a.f, b.f) || cmp(a.n, b.n); });
      var families = [];
      this.devices.forEach(function (d) { if (families.indexOf(d.f) < 0) families.push(d.f); });
      fam.innerHTML = '<option value="">Select brand</option>' + families.map(function (f) { return '<option value="' + esc(f) + '">' + esc(f) + '</option>'; }).join('');
      this.fillModels();
    }

    fillModels() {
      var fam = this.q('[data-bdl-fam]'), model = this.q('[data-bdl-model]');
      if (!fam || !model) return;
      var f = fam.value;
      model.innerHTML = '<option value="">Select your model</option>' + this.devices.map(function (d, i) {
        return d.f === f ? '<option value="' + i + '">' + esc(d.n) + '</option>' : '';
      }).join('');
      model.disabled = !f;
    }

    /* Fit context for one device. */
    ctxOf(dev) {
      if (!dev) return null;
      if (dev.kind === 'own') return { swt: dev.own, d: dev.own, name: dev.name };
      return { swt: dev.match || null, d: dev.match || this.pseudoDevice(dev.product), name: dev.name, product: dev.product };
    }

    /* The device a step is showing items for. */
    stepDev(step) {
      var key = this.state.active[step.id];
      return this.dev(key) || this.state.devs[0] || null;
    }

    devicesChanged() {
      this.renderDevices();
      this.renderSteps();
      this.render();
    }

    /* ======================= Add-on steps ======================= */
    loadSteps() {
      var self = this;
      (this.cfg.steps || []).forEach(function (step) {
        if (!step.handle) { self.data[step.id] = []; return; }
        self.loadCollection(step).then(function (items) {
          self.data[step.id] = self.cleanItems(items, step);
          self.renderSteps();
        }).catch(function () {
          self.data[step.id] = [];
          self.renderStep(step, 'Could not load these items. Refresh to try again.');
        });
      });
    }

    loadCollection(step) {
      var base = root + 'collections/' + encodeURIComponent(step.handle) + '?section_id=swt-bundle-data';
      var get = function (page) {
        return fetch(base + '&page=' + page, { headers: { Accept: 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var node = doc.querySelector('[data-bdl-data]');
            return node ? JSON.parse(node.textContent) : { page: page, pages: 1, items: [] };
          });
      };
      return get(1).then(function (first) {
        var pages = Math.min(first.pages || 1, 4);
        if (pages < 2) return first.items || [];
        var rest = [];
        for (var i = 2; i <= pages; i++) rest.push(get(i));
        return Promise.all(rest).then(function (more) {
          return more.reduce(function (all, chunk) { return all.concat(chunk.items || []); }, first.items || []);
        });
      });
    }

    cleanItems(items, step) {
      var self = this;
      var types = lower(list(step.types));
      var seen = {};
      return (items || []).filter(function (it) {
        if (!it || !it.a || seen[it.id]) return false;
        if (it.dw) return false; // Deals of the Week: not part of bundles
        if (self.cfg.excludeOpenBox && isOpenBox(it.t, it.tg)) return false;
        if (self.excl.indexOf(String(it.v || '').toLowerCase()) > -1) return false;
        if (types.length && types.indexOf(String(it.ty || '').toLowerCase()) < 0) return false;
        it.vs = (it.vs || []).filter(function (v) { return v.a && !(self.cfg.excludeOpenBox && isUsedSku(v.s)); });
        if (!it.vs.length) return false;
        seen[it.id] = true;
        return true;
      });
    }

    /* Does item fit the device? -> {s: ok|part|no|unknown, w, exact} */
    fit(it, ctx, step) {
      var f = this.fitRaw(it, ctx, step);
      if (step && step.fit === 'exact' && !f.exact) return { s: 'no' };
      return f;
    }

    fitRaw(it, ctx, step) {
      if (it.c && it.c.length) {
        if (!ctx.swt) return { s: 'unknown' };
        return it.c.indexOf(ctx.swt.h) > -1 ? { s: 'ok', w: 'Made for your ' + ctx.name, exact: true } : { s: 'no' };
      }
      if (it.r) return judgeRule(it.r, ctx.d);
      var fb = step && step.fallback;
      if (fb === 'bluetooth' || fb === 'charger') return judgeRule(fb, ctx.d);
      if (fb === 'title') {
        var names = [ctx.name];
        if (ctx.product) names.push(shortName(ctx.product.title));
        names.slice().forEach(function (n) {
          var parts = String(n || '').split(' ');
          if (parts.length > 2) names.push(parts.slice(1).join(' '));
        });
        var t = String(it.t || '').toUpperCase();
        var ok = names.some(function (n) {
          n = String(n || '').toUpperCase();
          var at = n ? t.indexOf(n) : -1;
          if (at < 0) return false;
          var next = t.charAt(at + n.length);
          return !next || !/[A-Z0-9+]/.test(next);
        });
        return ok ? { s: 'ok', w: 'Made for your ' + ctx.name, exact: true } : { s: 'no' };
      }
      return { s: 'unknown' };
    }

    bindSteps() {
      var self = this;
      (this.cfg.steps || []).forEach(function (step) {
        var sec = self.q('[data-bdl-step="' + step.id + '"]');
        if (!sec) return;
        var tabs = sec.querySelector('[data-bdl-for]');
        if (tabs) {
          tabs.addEventListener('click', function (e) {
            var b = e.target.closest('[data-bdl-fordk]');
            if (!b) return;
            self.state.active[step.id] = b.getAttribute('data-bdl-fordk');
            self.renderStep(step);
            var on = tabs.querySelector('[aria-pressed="true"]');
            if (on) on.focus({ preventScroll: true });
          });
        }
        var grid = sec.querySelector('[data-bdl-grid]');
        grid.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-bdl-add]');
          if (!btn || btn.disabled) return;
          var card = btn.closest('[data-bdl-item]');
          self.toggle(Number(card.getAttribute('data-bdl-item')), step, card);
        });
        grid.addEventListener('change', function (e) {
          var sel = e.target.closest('[data-bdl-variant]');
          if (!sel) return;
          var card = sel.closest('[data-bdl-item]');
          var it = self.itemById(step, Number(card.getAttribute('data-bdl-item')));
          var dev = self.stepDev(step);
          if (!it || !dev) return;
          var pick = self.findPick(it.id, dev.key);
          var v = it.vs.filter(function (x) { return x.id === Number(sel.value); })[0];
          if (!v) return;
          if (pick) { pick.variant = v; self.render(); }
          var price = card.querySelector('.swt-bdl__price');
          if (price) price.innerHTML = self.fmt(v.p) + (v.cp && v.cp > v.p ? '<s>' + self.fmt(v.cp) + '</s>' : '');
          var badge = card.querySelector('[data-bdl-offer]');
          if (badge) {
            var b = self.offerBadge(it, v);
            badge.textContent = b.text;
            badge.className = 'swt-bdl__offer ' + b.cls;
          }
        });
        var more = sec.querySelector('[data-bdl-more]');
        if (more) {
          more.addEventListener('click', function () {
            self.expanded[step.id] = !self.expanded[step.id];
            self.renderStep(step);
            if (!self.expanded[step.id]) sec.scrollIntoView({ block: 'start', behavior: 'auto' });
          });
        }
      });
    }

    renderSteps() {
      var self = this;
      (this.cfg.steps || []).forEach(function (step) { self.renderStep(step); });
    }

    renderStep(step, errorText) {
      var sec = this.q('[data-bdl-step="' + step.id + '"]');
      if (!sec) return;
      var grid = sec.querySelector('[data-bdl-grid]');
      var count = sec.querySelector('[data-bdl-count]');
      var moreWrap = sec.querySelector('[data-bdl-morewrap]');
      var tabs = sec.querySelector('[data-bdl-for]');
      var self = this;
      var devs = this.state.devs;
      var dev = this.stepDev(step);
      var ctx = this.ctxOf(dev);
      var items = this.data[step.id];
      moreWrap.hidden = true;
      count.textContent = '';
      sec.classList.toggle('is-done', this.state.picks.some(function (pk) { return pk.step.id === step.id; }));

      /* "For" tabs when the bundle has 2+ devices */
      if (tabs) {
        if (devs.length > 1) {
          tabs.innerHTML = '<span class="swt-bdl__forlabel">For</span>' + devs.map(function (d) {
            var n = self.state.picks.filter(function (pk) { return pk.step.id === step.id && pk.dev === d.key; }).length;
            return '<button type="button" class="swt-v2-option swt-bdl__forbtn" data-bdl-fordk="' + d.key + '" aria-pressed="' + (dev && d.key === dev.key ? 'true' : 'false') + '" data-track-action="addon-device-tab">' +
              '<span>' + esc(self.label(d)) + '</span>' + (n ? '<span class="swt-bdl__forn">' + n + '</span>' : '') + '</button>';
          }).join('');
          tabs.hidden = false;
        } else {
          tabs.hidden = true;
          tabs.innerHTML = '';
        }
      }

      if (errorText) { grid.innerHTML = '<p class="swt-bdl__empty">' + esc(errorText) + '</p>'; return; }
      if (!ctx) { grid.innerHTML = '<p class="swt-bdl__empty">' + esc(this.lockText) + '</p>'; return; }
      if (!items) { grid.innerHTML = '<span class="swt-bdl__skel"></span><span class="swt-bdl__skel"></span>'; return; }

      var claimed = this.claimedBefore(step, ctx);
      var brand = String((ctx.product && ctx.product.vendor) || String(ctx.d.f || '').split(' ')[0] || '').toLowerCase();
      var shown = items.filter(function (it) { return !claimed[it.id]; })
        .map(function (it, i) { return { it: it, f: self.fit(it, ctx, step), i: i }; })
        .filter(function (x) { return x.f.s === 'ok' || x.f.s === 'part'; });
      var rank = function (x) {
        return (x.f.exact ? 4 : 0) + (String(x.it.v || '').toLowerCase() === brand ? 2 : 0) + (x.f.s === 'ok' ? 1 : 0);
      };
      shown.sort(function (a, b) { return (rank(b) - rank(a)) || (a.i - b.i); });

      if (!shown.length) {
        grid.innerHTML = '<p class="swt-bdl__empty">Nothing here fits your ' + esc(this.label(dev)) + ' yet.</p>';
        return;
      }
      count.textContent = shown.length + ' fit';
      var per = this.cfg.perStep || 4;
      var limit = this.expanded[step.id] ? shown.length : per;
      var picksHere = this.state.picks.filter(function (pk) { return pk.step.id === step.id && pk.dev === dev.key; }).length;
      /* Picked items always stay visible, even past the limit. */
      var visible = shown.slice(0, limit);
      shown.slice(limit).forEach(function (x) { if (self.findPick(x.it.id, dev.key)) visible.push(x); });
      grid.innerHTML = visible.map(function (x) { return self.itemHtml(x.it, x.f, step, picksHere, ctx, brand, dev); }).join('');
      if (shown.length > per) {
        moreWrap.hidden = false;
        var btn = moreWrap.querySelector('[data-bdl-more]');
        btn.textContent = this.expanded[step.id] ? 'Show less' : 'Show all ' + shown.length;
        btn.setAttribute('aria-expanded', this.expanded[step.id] ? 'true' : 'false');
      }
    }

    /* Items an earlier step already shows for this device, so one product
       never shows twice. */
    claimedBefore(step, ctx) {
      var out = {}, self = this;
      var steps = this.cfg.steps || [];
      for (var i = 0; i < steps.length && steps[i].id !== step.id; i++) {
        (this.data[steps[i].id] || []).forEach(function (it) {
          if (out[it.id]) return;
          var f = self.fit(it, ctx, steps[i]);
          if (f.s === 'ok' || f.s === 'part') out[it.id] = true;
        });
      }
      return out;
    }

    itemHtml(it, f, step, picksHere, ctx, brand, dev) {
      var pick = this.findPick(it.id, dev.key);
      var vid = pick ? pick.variant.id : it.vs[0].id;
      var v = it.vs.filter(function (x) { return x.id === vid; })[0] || it.vs[0];
      var fmt = this.fmt;
      var fitText = f.w || '';
      var sameBrand = brand && String(it.v || '').toLowerCase() === brand;
      if (it.nt && f.s !== 'no') {
        /* Notes say "full speed on brand X, standard speed on others": on the
           same brand say the short version, elsewhere show the note. */
        if (sameBrand && (it.r === 'charger' || it.r === 'usb_c')) fitText = 'Full speed on your ' + ctx.name;
        else if (!fitText || it.nt.toLowerCase().indexOf(fitText.toLowerCase()) > -1) fitText = it.nt;
        else if (fitText.toLowerCase().indexOf(it.nt.toLowerCase()) < 0) fitText = fitText + '. ' + it.nt;
      }
      var select = '';
      if (it.vs.length > 1) {
        select = '<select data-bdl-variant aria-label="Option for ' + esc(it.t) + '">' + it.vs.map(function (x) {
          return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(x.t) + ' · ' + fmt(x.p) + '</option>';
        }).join('') + '</select>';
      }
      var max = step.max || 99;
      var swap = max === 1 && picksHere > 0 && !pick;
      var full = picksHere >= max;
      var disabled = !pick && full && !swap;
      var label = pick ? 'Added' : (swap ? 'Swap in' : (disabled ? 'Max ' + max + ' here' : 'Add'));
      var icon = pick ? ICON_CHECK : (swap ? ICON_SWAP : ICON_PLUS);
      var badge = this.offerBadge(it, v);
      return '<article class="swt-bdl__item' + (pick ? ' is-picked' : '') + '" data-bdl-item="' + it.id + '">' +
        '<span class="swt-bdl__item-img">' + (it.img ? '<img src="' + esc(img(it.img, 400)) + '" alt="" loading="lazy" width="400" height="400">' : '') + '</span>' +
        '<span class="swt-bdl__item-v">' + esc(it.v) + '</span>' +
        '<span class="swt-bdl__itemtext"><a class="swt-bdl__item-t" href="' + esc(it.u) + '" target="_blank" rel="noopener">' + esc(it.t) + '</a>' +
          (fitText ? '<span class="swt-bdl__fit' + (f.s === 'part' ? ' is-part' : '') + '" title="' + esc(fitText) + '">' + (f.s === 'part' ? ICON_INFO : ICON_CHECK) + '<span>' + esc(fitText) + '</span></span>' : '') +
          '<span class="swt-bdl__offer ' + badge.cls + '" data-bdl-offer>' + esc(badge.text) + '</span>' +
        '</span>' +
        '<span class="swt-bdl__item-foot">' +
          '<span class="swt-bdl__price">' + fmt(v.p) + (v.cp && v.cp > v.p ? '<s>' + fmt(v.cp) + '</s>' : '') + '</span>' +
          select +
          '<button type="button" class="swt-bdl__add" data-bdl-add aria-pressed="' + (pick ? 'true' : 'false') + '"' + (disabled ? ' disabled' : '') +
            ' aria-label="' + esc((pick ? 'Remove ' : (swap ? 'Swap in ' : 'Add ')) + it.t) + '" data-track-action="addon-toggle">' +
            icon + '<span>' + label + '</span></button>' +
        '</span>' +
      '</article>';
    }

    /* ===== Bundle rules (same as the discount function) ===== */
    roleOf(type) {
      var t = String(type || '').trim().toLowerCase();
      if (this.types.indexOf(t) > -1) return 'device';
      if (this.addonTypes.indexOf(t) > -1) return 'addon';
      return 'ignored';
    }

    /* What an add-on variant does in a bundle: {counts, device, max, why} */
    offerOf(it, v) {
      var role = this.roleOf(it.ty);
      if (role === 'device') return { counts: true, device: true, max: 0, why: 'Counts as your device', short: 'Counts · not discounted' };
      if (role !== 'addon') return { counts: false, max: 0, why: 'Doesn’t count toward the bundle', short: 'Doesn’t count' };
      if (!(v.p >= this.minCents)) return { counts: false, max: 0, why: 'Under ' + this.fmt(this.minCents) + ' · doesn’t count', short: 'Under ' + this.fmt(this.minCents) + ' · doesn’t count' };
      var m = Number(v.m);
      var max = m > 0 ? Math.min(m, this.ceiling) : 0;
      if (v.cp && v.cp > v.p) return { counts: true, max: 0, why: 'On sale · counts, no extra %', short: 'On sale · counts, no %' };
      if (isUsedSku(v.s) || isOpenBox(it.t, it.tg)) return { counts: true, max: 0, why: 'Open Box · counts, no extra %', short: 'Open Box · counts, no %' };
      if (!(max > 0)) return { counts: true, max: 0, why: 'Counts toward your saving · no % off', short: 'Counts · no % off' };
      return { counts: true, max: max, why: '', short: 'Counts' };
    }

    offerBadge(it, v) {
      var o = this.offerOf(it, v);
      var top = this.tiers.length ? this.tiers[this.tiers.length - 1].p : 0;
      if (o.counts && o.max > 0) return { text: 'Bundle: up to ' + Math.min(o.max, top) + '% off', cls: 'is-save' };
      return { text: o.why, cls: o.counts ? 'is-count' : 'is-none' };
    }

    /* Count + per-line saving, exactly like checkout. */
    calc(lines) {
      var devUnits = 0, products = {}, order = [];
      lines.forEach(function (l) {
        if (l.device || (l.offer && l.offer.device)) { devUnits += 1; return; }
        if (!l.offer || !l.offer.counts) return;
        if (!products[l.pid]) { products[l.pid] = []; order.push(l.pid); }
        if (l.offer.max > 0) products[l.pid].push(l);
      });
      var counted = Math.min(devUnits, this.maxDev) + order.length;
      var tier = this.tierFor(counted);
      var res = { counted: counted, tier: tier, per: {}, saving: 0, capped: false };
      if (!tier) return res;
      order.forEach(function (pid) {
        var best = null;
        products[pid].forEach(function (l) {
          var pct = Math.min(tier.p, l.offer.max);
          var cents = Math.round((l.price * pct) / 100);
          if (cents > 0 && (!best || cents > best.cents)) best = { key: l.key, pct: pct, cents: cents };
        });
        if (best) res.per[best.key] = best;
      });
      var keys = Object.keys(res.per);
      var total = keys.reduce(function (a, k) { return a + res.per[k].cents; }, 0);
      if (total > this.capCents && this.capCents > 0) {
        var cap = this.capCents, scaled = 0;
        res.capped = true;
        keys.forEach(function (k) {
          var c = Math.floor((res.per[k].cents * cap) / total);
          if (c > 0) { res.per[k].cents = c; scaled += c; } else { delete res.per[k]; }
        });
        total = scaled;
      }
      res.saving = total;
      return res;
    }

    itemById(step, id) { return (this.data[step.id] || []).filter(function (x) { return x.id === id; })[0]; }
    findPick(id, key) { return this.state.picks.filter(function (pk) { return pk.item.id === id && pk.dev === key; })[0]; }

    toggle(id, step, card) {
      var it = this.itemById(step, id);
      var dev = this.stepDev(step);
      if (!it || !dev) return;
      var pick = this.findPick(id, dev.key);
      if (pick) {
        this.state.picks = this.state.picks.filter(function (pk) { return pk !== pick; });
        this.say(it.t + ' removed.');
      } else {
        var sel = card.querySelector('[data-bdl-variant]');
        var vid = sel ? Number(sel.value) : it.vs[0].id;
        var v = it.vs.filter(function (x) { return x.id === vid; })[0] || it.vs[0];
        var mine = this.state.picks.filter(function (pk) { return pk.step.id === step.id && pk.dev === dev.key; });
        if ((step.max || 99) === 1 && mine.length) {
          this.state.picks = this.state.picks.filter(function (pk) { return mine.indexOf(pk) < 0; });
          this.say(mine[0].item.t + ' swapped for ' + it.t + '.');
        } else {
          this.say(it.t + ' added.');
        }
        this.state.picks.push({ item: it, variant: v, step: step, dev: dev.key });
      }
      this.hideDone();
      this.renderStep(step);
      this.render();
      var again = this.q('[data-bdl-step="' + step.id + '"] [data-bdl-item="' + id + '"] [data-bdl-add]');
      if (again) again.focus({ preventScroll: true });
    }

    /* ======================= Summary ======================= */
    bindSummary() {
      var self = this;
      var sum = this.q('[data-bdl-sum]');
      var toggle = this.q('[data-bdl-toggle]');
      var setOpen = function (open) {
        sum.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      this.setSheet = setOpen;
      if (toggle) {
        toggle.addEventListener('click', function () { setOpen(!sum.classList.contains('is-open')); });
      }
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sum.classList.contains('is-open')) { setOpen(false); toggle.focus(); }
      });
      var listEl = this.q('[data-bdl-list]');
      if (listEl) {
        listEl.addEventListener('click', function (e) {
          var rm = e.target.closest('[data-bdl-rm]');
          if (!rm) return;
          var key = rm.getAttribute('data-bdl-rm').split(':');
          if (key[0] === 'dev') { self.removeDevice(key[1]); return; }
          var pick = self.findPick(Number(key[1]), key[2]);
          if (!pick) return;
          self.state.picks = self.state.picks.filter(function (pk) { return pk !== pick; });
          self.renderStep(pick.step);
          self.render();
          self.say(pick.item.t + ' removed.');
          var next = listEl.querySelector('[data-bdl-rm]');
          (next || toggle).focus({ preventScroll: true });
        });
      }
      var cta = this.q('[data-bdl-cta]');
      if (cta) cta.addEventListener('click', function () { self.addToCart(); });
    }

    lines() {
      var s = this.state, out = [], self = this;
      var many = s.devs.length > 1;
      s.devs.forEach(function (d) {
        var name = self.label(d);
        if (d.kind === 'new') {
          var v = d.variant;
          out.push({
            key: 'dev:' + d.key, dk: d.key, device: true, id: v.id, price: v.price,
            title: name,
            sub: (v.title && v.title !== 'Default Title') ? v.title : d.product.vendor,
            img: (v.featured_image && v.featured_image.src) || d.product.featured_image || ''
          });
        }
        s.picks.filter(function (pk) { return pk.dev === d.key; }).forEach(function (pk) {
          var sub = (pk.variant.t && pk.variant.t !== 'Default Title') ? pk.variant.t : pk.step.title;
          out.push({
            key: 'pick:' + pk.item.id + ':' + d.key, dk: d.key, device: false, id: pk.variant.id, price: pk.variant.p,
            title: pk.item.t, sub: many ? sub + ' · for ' + name : sub,
            img: pk.item.img, pid: pk.item.id, offer: self.offerOf(pk.item, pk.variant)
          });
        });
      });
      return out;
    }

    tierFor(n) {
      var hit = null;
      this.tiers.forEach(function (t) { if (n >= t.q) hit = t; });
      return hit;
    }

    render() {
      var fmt = this.fmt;
      var lines = this.lines();
      var cfg = this.cfg;
      var r = this.calc(lines);
      var n = r.counted;
      var tier = r.tier;
      var subtotal = lines.reduce(function (a, l) { return a + l.price; }, 0);
      var saving = r.saving;
      var total = subtotal - saving;
      var on = ' on add-ons';
      var sum = this.q('[data-bdl-sum]');
      sum.classList.toggle('is-empty', !lines.length);

      this.q('[data-bdl-countlabel]').textContent = plural(lines.length, 'item', 'items');
      this.q('[data-bdl-bartotal]').textContent = lines.length ? fmt(total) : '';
      this.q('[data-bdl-sub]').textContent = fmt(subtotal);
      this.q('[data-bdl-total]').textContent = fmt(total);
      var saveRow = this.q('[data-bdl-saverow]');
      saveRow.hidden = !saving;
      if (saving) {
        this.q('[data-bdl-savelabel]').textContent = r.capped ? 'Bundle saving (max ' + fmt(this.capCents) + ')' : 'Bundle saving';
        this.q('[data-bdl-save]').textContent = '−' + fmt(saving);
      }

      /* Meter: marks sit at each tier on a scale up to the top tier + 1 */
      var top = this.tiers.length ? this.tiers[this.tiers.length - 1].q : 5;
      var scale = top + 1;
      var fill = this.q('[data-bdl-fill]');
      fill.style.width = Math.min(100, (n / scale) * 100) + '%';
      var marks = [this.q('[data-bdl-mark1]'), this.q('[data-bdl-mark2]')];
      var tiers = this.tiers;
      marks.forEach(function (m, i) {
        if (!m) return;
        var t = tiers[i];
        if (!t) { m.hidden = true; return; }
        m.style.left = (t.q / scale) * 100 + '%';
        m.textContent = t.p + '%';
        m.classList.toggle('is-hit', n >= t.q);
      });

      /* Hint: long (sheet + desktop) and short (phone bar) */
      var next = null;
      this.tiers.forEach(function (t) { if (!next && n < t.q) next = t; });
      var first = this.tiers[0] || { q: 3, p: 10 };
      var more = function (k) { return plural(k, 'more item', 'more items'); };
      var hint = '', short = '';
      if (!lines.length) {
        hint = 'Add ' + first.q + ' items to save up to ' + first.p + '%' + on + '.';
        short = 'Add ' + first.q + ' items to save up to ' + first.p + '%';
      } else if (!tier && next) {
        hint = 'Add ' + more(next.q - n) + ' to save up to ' + next.p + '%' + on + '.';
        short = 'Add ' + (next.q - n) + ' more to save up to ' + next.p + '%';
      } else if (tier && !saving) {
        hint = 'You reached up to ' + tier.p + '%, but these add-ons don’t carry a bundle %. Look for “Bundle: up to” items.';
        short = 'No % on these items yet';
      } else if (tier && next) {
        hint = 'You save ' + fmt(saving) + '. Add ' + more(next.q - n) + ' to save up to ' + next.p + '%' + on + '.';
        short = 'Saving ' + fmt(saving) + ' · ' + (next.q - n) + ' more for ' + next.p + '%';
      } else if (tier) {
        hint = 'Top tier: you save ' + fmt(saving) + (r.capped ? ' (the most per order)' : '') + '.';
        short = 'Top tier · saving ' + fmt(saving);
      }
      this.q('[data-bdl-hint]').innerHTML = '<span class="swt-bdl__hint-long">' + esc(hint) + '</span><span class="swt-bdl__hint-short" aria-hidden="true">' + esc(short) + '</span>';

      /* Lines */
      var listEl = this.q('[data-bdl-list]');
      listEl.innerHTML = lines.length ? lines.map(function (l) {
        var pl = r.per[l.key];
        var note = '', cls = 'is-none';
        if (l.device) note = 'Counts · not discounted';
        else if (pl) { note = '−' + fmt(pl.cents) + ' bundle' + (r.capped ? '' : ' (' + pl.pct + '%)'); cls = 'is-save'; }
        else if (l.offer && (!l.offer.counts || l.offer.max <= 0)) note = l.offer.short;
        else if (tier) note = 'Counts · % on 1 of each';
        else note = 'Counts';
        return '<li class="swt-bdl__line">' +
          (l.img ? '<img src="' + esc(img(l.img, 120)) + '" alt="" width="48" height="48">' : '<span></span>') +
          '<span class="swt-bdl__line-t"><strong>' + esc(l.title) + '</strong><small>' + esc(l.sub || '') + '</small>' +
            '<em class="swt-bdl__line-note ' + cls + '">' + esc(note) + '</em></span>' +
          '<span class="swt-bdl__line-r">' + fmt(l.price) +
            '<button type="button" class="swt-bdl__rm" data-bdl-rm="' + esc(l.key) + '" aria-label="Remove ' + esc(l.title) + '">' + ICON_X + '</button></span>' +
        '</li>';
      }).join('') : '<li class="swt-bdl__listempty">Nothing yet. Start with step 1.</li>';

      /* CTA */
      var cta = this.q('[data-bdl-cta]');
      cta.disabled = !lines.length;
      var label = cfg.cta || 'Add bundle to cart';
      this.q('[data-bdl-ctalong]').textContent = lines.length ? label + ' · ' + fmt(total) : label;
    }

    hideDone() {
      var d = this.q('.swt-bdl__done');
      if (d) d.remove();
    }

    showError(msg) {
      var el = this.q('[data-bdl-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = !msg;
      if (msg) {
        window.clearTimeout(this.errTimer);
        this.errTimer = window.setTimeout(function () { el.hidden = true; }, 6000);
      }
    }

    addToCart() {
      var self = this;
      var lines = this.lines();
      if (!lines.length || this.busy) return;
      var size = this.calc(lines).counted;
      var id = bundleId();
      var items = lines.map(function (l) {
        return { id: l.id, quantity: 1, properties: { _bundle: id, _bundle_size: String(size), _bundle_role: l.device ? 'device' : 'addon', _bundle_for: l.dk } };
      });
      var cta = this.q('[data-bdl-cta]');
      this.busy = true;
      this.showError('');
      cta.classList.add('is-loading');
      cta.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Could not add your bundle. Please try again.');
            return data;
          });
        })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('swt:cart:added', { detail: { source: 'bundle', bundle: id, items: data } }));
          self.reset();
          var done = document.createElement('p');
          done.className = 'swt-bdl__done';
          done.textContent = 'Your bundle is in the cart.';
          self.q('[data-bdl-hint]').after(done);
          self.say('Your bundle is in the cart.');
          if (self.setSheet) self.setSheet(false);
          if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
            window.Rebuy.SmartCart.show();
          } else {
            window.location.href = root + 'cart';
          }
        })
        .catch(function (err) {
          self.showError(err && err.message ? err.message : 'Could not add your bundle. Please try again.');
        })
        .finally(function () {
          self.busy = false;
          cta.classList.remove('is-loading');
          cta.removeAttribute('aria-busy');
        });
    }

    /* After add to cart: clear picks and new devices, keep the ones the
       shopper already owns (they still own them). */
    reset() {
      var self = this;
      this.state.picks = [];
      this.state.devs = this.state.devs.filter(function (d) { return d.kind === 'own'; });
      Object.keys(this.state.active).forEach(function (sid) {
        if (!self.dev(self.state.active[sid])) delete self.state.active[sid];
      });
      this.state.adderOpen = !this.state.devs.length;
      this.devicesChanged();
    }
  }

  customElements.define('swt-bundle', SwtBundle);
})();
